module.exports = __webpack_public_path__ + "static/grunt-7835f1c5e7f781ce68eba53c4e93cd69.svg";